import { lazy, Suspense } from 'react';
import { Route } from 'react-router';
import { csrdRoutePaths } from 'core/lib/routePaths/csrdRoutePaths';
import { RouteLoader } from '#components/Loader/RouteLoader';

const Csrd = lazy(() => import('csrd/central-routes/csrd-routes'));

const CSRDHome = lazy(() =>
  import('csrd/central-routes/csrd-routes').then((module) => ({
    default: module.HomeRoute,
  })),
);

const About = lazy(() =>
  import('csrd/central-routes/csrd-routes').then((module) => ({
    default: module.AboutRoute,
  })),
);

const Pricing = lazy(() =>
  import('csrd/central-routes/csrd-routes').then((module) => ({
    default: module.CSRDPricingRoute,
  })),
);

const Checkout = lazy(() =>
  import('csrd/central-routes/csrd-routes').then((module) => ({
    default: module.CheckoutRoute,
  })),
);

const Confirmation = lazy(() =>
  import('csrd/central-routes/csrd-routes').then((module) => ({
    default: module.ConfirmationRoute,
  })),
);

const SubscriptionCheckout = lazy(() =>
  import('csrd/central-routes/csrd-routes').then((module) => ({
    default: module.SubscriptionCheckoutRoute,
  })),
);

const SubscriptionConfirmation = lazy(() =>
  import('csrd/central-routes/csrd-routes').then((module) => ({
    default: module.SubscriptionConfirmationRoute,
  })),
);

const Overview = lazy(() =>
  import('csrd/central-routes/csrd-routes').then((module) => ({
    default: module.OverviewRoute,
  })),
);

export const CSRDRouteTree = (
  <Route
    path={csrdRoutePaths.HOME}
    element={
      <Suspense fallback={<RouteLoader />}>
        <Csrd />
      </Suspense>
    }
  >
    <Route index element={<CSRDHome />} />,
    <Route path={csrdRoutePaths.OVERVIEW} element={<Overview />} />,
    <Route path={csrdRoutePaths.ABOUT} element={<About />}>
      <Route path={csrdRoutePaths.ABOUT_CSRD_AND_REPORTING_STANDARDS} element={<About />} />
      <Route path={csrdRoutePaths.ABOUT_METHODOLOGY_AND_TRACEABILITY} element={<About />} />
      <Route path={csrdRoutePaths.ABOUT_REPORTING_STANDARDS} element={<About />} />
      <Route path={csrdRoutePaths.ABOUT_CSRD} element={<About />} />
      <Route path={csrdRoutePaths.ABOUT_STENAS_OFFER} element={<About />} />
    </Route>
    <Route path={csrdRoutePaths.PRICING} element={<Pricing />} />,
    <Route path={csrdRoutePaths.CHECKOUT} element={<Checkout />} />,
    <Route path={csrdRoutePaths.SUBSCRIPTION_CHECKOUT} element={<SubscriptionCheckout />} />,
    <Route path={csrdRoutePaths.SUBSCRIPTION_CONFIRMATION} element={<SubscriptionConfirmation />} />
    ,
    <Route path={csrdRoutePaths.CONFIRMATION} element={<Confirmation />} />
  </Route>
);

export const preloadCSRD = () => {
  //Import default export to trigger preload
  void import('csrd/central-routes/csrd-routes');
};
